<template>
    <div>
        <a id="kirurg-interview"></a>
        <div class="news-row" style="padding-top: 20px">
            <img class="news-photo" src="../assets/news/kirurg1.jpg"
                 @click="displayKirurgInterview = !displayKirurgInterview">
            <div class="news-row_column">
                <p class="news-header">
                    Perhaps not so unknown for the locals, DJ 4-got-10 decided at one point that he would like to create
                    the kind of music that he longs to play in his sets and that does not fit in the realms of his main
                    bands Forgotten Sunrise and Deceitome.
                </p>
                <p class="news-header read-more"
                   @click="displayKirurgInterview = !displayKirurgInterview">―
                    READ THE INTERVIEW WITH KIRURG BY EVERT PALMETS</p>
            </div>
        </div>
        <div v-show="displayKirurgInterview" class="interview">
            <p class="interview_question">
                So, you have a new alias as a performing artist. Tell us about it, for how far in the
                beginning of something exactly are you?
            </p>
            <p class="interview_answer">
                Yeah, I've been a DJ for 20+ years and I had some kind of need to create similar type of tunes which I
                prefer to play as a DJ. So, I formed Kirurg finally. It's a new thing for me to create music with
                totally different mindset. It's completely different world how I make music for Forgotten Sunrise and I
                like it. Kirurg is more flow oriented and meant for dancefloors. Yes, I'm in the beginning... not so
                far.
            </p>

            <p class="interview_question">
                You are now having your first live experience as a surgeonist. But I have to ask about your health, is
                the alias and you deeply connected for the recent causes? Your first EVER show cancellation... you NEVER
                cancel anything! So, yeah, please tell us about the name "Kirurg?"
            </p>
            <p class="interview_answer">
                Kirurg is good name I think. Surgeon wasn't in my mind at all at the time when I chose this name. I'm
                not into this kind of techno anyway. About cancellation of last Forgotten Sunrise performance, yes I was
                totally sick and what could I do. Now it's in the past already and I'm focusing to Saturday, my very
                first performance with Kirurg. I'm sure I will surprise myself too. I'd like to make it spontaneous and
                put some real rock'n roll energy into cold techno type of music, more muscle, more danger!
            </p>

            <p class="interview_question">
                Kirurg has some songs to say, which one is your proudest one?
            </p>
            <p class="interview_answer">
                I like all my tracks you know, my children. I still laugh at „Beats From The Vault“ track and it's my
                favorite at the moment I think. Yesterday I started a new track „Kirurgitate“ and it seems that when
                it's done, it's my next favorite.
            </p>

            <p class="interview_question">
                Music is a reasonable part of your everyday. Step by step you are dissolving to particular. If I asked
                before how far in the beginning are you - this question is about the depth. What worries you the most,
                what's your biggest obstacle on the way to the near-future?
            </p>
            <p class="interview_answer">
                Time, lifetime. We never know how much time we have left and I feel pressure because I know how much
                wonderful things I still want to do before I die.
            </p>

            <p class="interview_question">
                What happens after Body Machine Body festival 2019? Let's start with the afterparty.
            </p>
            <p class="interview_answer">
                You mean after party after after party? I wanna create more tracks with Kirurg and prepare for the
                future shows. Hope to play more often under this moniker. As a DJ people hear me at every Beats From The
                Vault anyway. I need more live action in my life.
            </p>

            <p class="interview_question">
                Do you have a fresh night-dream or nightmare story to share with us?
            </p>
            <p class="interview_answer">
                Nothing fresh to tell. The weirdest dream was already some months ago when I felt in my dream that
                there's some kind of ghost in my room. I was sleeping besides Kadri also in my dream as in real life. I
                wanted to scare this weird spirit before s/he scares me and I started to shout with weird low voice
                „Samba, sambaaa, sambaaaa!“ and then Kadri woke me up because I did this voice also outside of this
                dream. Who knows, maybe „samba“ is the scariest word to scare bad spirits away.
            </p>
        </div>

        <a id="bestial-mouths-interview"></a>
        <div class="news-row" style="padding-top: 20px">
            <img class="news-photo" src="../assets/news/bm.jpg"
                 @click="displayBestialMouthsInterview = !displayBestialMouthsInterview">
            <div class="news-row_column">
                <p class="news-header">
                    This is the one and only Bestial Mouths! Gloomy gothic substance, dark wave like sound, and a fair
                    amount of exciting disarrangement and noise that creates a sonic journey alongside the darker
                    corners of life. Check out what their charismatic and unearthly mastermind and vocalist Lynette
                    Cerezo has to say.
                </p>
                <p class="news-header read-more"
                   @click="displayBestialMouthsInterview = !displayBestialMouthsInterview">―
                    READ THE INTERVIEW WITH BESTIAL MOUTHS BY MARILIIS MÕTTUS</p>
            </div>
        </div>
        <div v-show="displayBestialMouthsInterview" class="interview">
            <p class="interview_question">
                Your new album “INSHROUDSS” is gonna be out on October 28th, which is just days away. With what kind of
                state of mind was this EP made? How does it differ from what you´ve done so far?
            </p>
            <p class="interview_answer">
                “INSHROUDSS” is one of my most personal albums to date. Not only does it differ in being the first
                Bestial release I wrote all the lyrics and direction/concept for, it's also all about the journey I have
                been through since the last album “HEARTLESS”. It talks about real, honest emotion coming from a divorce
                of 10 years, taking Bestial Mouths as mine – my ex-husband and I started the band together – plus all
                the self-doubt, sadness, and stagnation involved in life. It's my pure truth and raw emotion.
            </p>

            <p class="interview_question">
                Lynette, you have said that you grew up listening to punk, goth, industrial and other darker music
                genres. Can you remember what was your first encounter with this kind of music? How did it start to grow
                on you?
            </p>
            <p class="interview_answer">
                One of my earliest and best memories was being 13 and getting to meet The Ramones at the only cool
                record shop at the time in Orlando, Murmur Records – then going with my best friend's older punk
                siblings to the show. From then on I never looked back and knew it was in my blood.
            </p>

            <p class="interview_question">
                Every genre has its own particular face with certain symbols and signs. Bestial Mouths definitely
                carries a dark, deep, melancholic, yet somewhat hopeful sound in itself. How would you describe the
                formation of the identity of Bestial Mouths?
            </p>
            <p class="interview_answer">
                Thank you for recognizing the depth of what we convey. I don’t believe I can describe it, as it was
                never planned to be something specifically identified. It was us, which is the past, present and future.
                Intended to make the listener connect or feel in the level or way they can. It is life, which is pain
                and suffering. It is being afraid to look death in the face, continuing to move forward yet wondering
                why.
            </p>

            <p class="interview_question">
                There´s a lot of tribal beats in the creation of Bestial Mouths. Do you have a deeper relation or
                interest in any particular ethnic group that has musically and culturally influenced you?
            </p>
            <p class="interview_answer">
                I love tribal drumming, the raw power and emotion connected to it. Maybe that comes from my Latin
                heritage, as I am Puerto Rican. From a child my parents have had amazing parties with live musicians and
                drums. It moves you.
            </p>

            <p class="interview_question">
                What has making music taught you as a person?
            </p>
            <p class="interview_answer">
                How to be truly alive. How to face all fears and become fearless – or shall I say, “DEATHLESS”.
            </p>

            <p class="interview_question">
                How do you spend your free time when you are not making any music?
            </p>
            <p class="interview_answer">
                I am kind of a hyper person so I don’t have much free time. If I am not moving I am probably sleeping.
                Sleeping is the best recharge, though I do suffer from bad nightmares – “even in my dreams the screaming
                never stops” are lyrics taken from experience. But I love to make jewelry as my mediation; taking
                discarded and broken objects and connecting them with powerful crystals. Animals are my number one
                savior in this world. Plus the trees.
            </p>

            <p class="interview_question">
                Name 3 movies that describe you the most and why?
            </p>
            <p class="interview_answer">
                “Pan's Labyrinth” – I love how beautifully it evokes the inherent darkness of fairy tales.
                “Let The Right One In” – A classic theme with a black and surreal edge, a lonely, bullied child is able
                to harness strength thanks to a profound friendship. Because in this world the only thing we truly have
                is each other.
                “A Girl Walks Home Alone At Night” – A strong contemporary female character who isn't overly-sexualized
                or overly-hysterical, preying on those who oppress and hurt woman – YES. Strikingly shot in black and
                white, the calm, slow pace add to the creepiness.
            </p>

            <p class="interview_question">
                Lastly, can you name five artists you are currently listening to?
            </p>

            <p class="interview_answer">
                SRSQ, Zanias, Lingua Ignota, Dead Can Dance (one of the few male voices I love), Jane's Addiction (same)
            </p>
        </div>

        <a id="plastic-whore-interview"></a>
        <div class="news-row" style="padding-top: 20px">
            <img class="news-photo" src="../assets/news/pw.jpg"
                 @click="displayPlasticWhoreInterview = !displayPlasticWhoreInterview">
            <div class="news-row_column">
                <p class="news-header">Plastic Whore's new coming, 15 years later on the anniversary of Wet Planet, will
                    be right before your eyes and ears in full glory in October!</p>
                <p class="news-header read-more" @click="displayPlasticWhoreInterview = !displayPlasticWhoreInterview">―
                    READ THE INTERVIEW WITH PLASTIC WHORE BY MAGNUS ALTKÜLA</p>
            </div>
        </div>
        <div v-show="displayPlasticWhoreInterview" class="interview">
            <p class="interview_question">
                Plastic Whore has been an inactive project for over ten years now. What made you bring it back to life
                for Body Machine Body?
            </p>
            <p class="interview_answer">
                Last year Anders (the organizer of Body Machine Body -edit) mentioned something along the
                lines of “it’d be cool to have Plastic Whore playing at BMB” and as I'm the one to get all
                excited quite easily, then here we are now.
            </p>

            <p class="interview_question">
                Plastic Whore’s debut and only album „Wet Planet“ was released already fifteen years ago. How do you
                view the material on that record nowadays? What kind of emotions does it make you feel? Pride,
                nostalgia, a desire to better the material?
            </p>
            <p class="interview_answer">
                It might sound narcissistic af, but I do like it a lot and I’m listening to it every now and then,
                as I do with most of the music I’ve made. Although I’m never a hundred percent happy with
                anything I’ve done and I think that’s the way it should be, cause in my opinion the day an
                artist is completely satisfied with the work, is also the last day of his or hers career. OK,
                maybe not exactly the last day, but the downward spiral begins right there.
                Anyway - pride, nostalgia? Yes, bit of both. Also, an itch to work with something new.
            </p>

            <p class="interview_question">
                During recent years you’ve had a hiatus from performing live. Does the upcoming Plastic Whore show hold
                some kind of a special significance for you as well? That after working on a bunch of other projects
                post-Plastic Whore (Skull Trading, Talbot, Odota, Hjem, Blood Pavilion, and others) it’s like a
                completion of a chapter, or a possible kickstarter for a renewed performer life? How do you feel about
                performing live in general at the moment? Would you ideally like to do it more often or are you, in
                contrast, enjoying your time away from the life of an active performer?
            </p>
            <p class="interview_answer">
                Yeah, it’s been a break all right. The last show I played was with Odota in late 2015 while the
                Japan tour and the last time I played drums was at the Roskilde Festival 2013 with Talbot.
                Not really a completion of a chapter for me, but it just might be a kickstarter indeed. Being
                away for a while from making music has definitely been good, I'm feeling a bit fresher now.
                As far as playing live goes I’m not really sure yet if I’d like to do it very often, semi often or
                not that often. I did like to be on stage and play the music, but all the fuzz with staying up late
                and waiting for the soundcheck, then sound-checking and then waiting for the show and so on
                doesn’t really excite me that much. Then again it might just be that I’ve become a lazy pig,
                haha. Well, time will tell. If at some there’s some period of active gigging and touring coming
                up, then probably I won’t be doing it against the will.
            </p>

            <p class="interview_question">
                Sticking with similar themes: what do you miss about active touring and creation of music, if you miss
                anything at all? And consequently: what made you step away from it?
            </p>
            <p class="interview_answer">
                I’d say it’s all been a love-hate relationship for me. Don’t know how to explain it any better.
            </p>

            <p class="interview_question">
                You used to tour a lot, especially with Talbot. What are some life lessons that you learned while being
                on the road?
            </p>
            <p class="interview_answer">
                It’s not the end of the world when the tour van breaks down on the road again (and it did
                happen quite a lot of times), because you’re not really just gonna die right there and then. The
                situation might seem like a total catastrophe, depending on how seriously something broke,
                but there’s always some kind of solution coming up. Yes, you might not like it and it might
                take a lot more time than you’d want, but something will happen, eventually - you’ll get some
                temporary fix or find a tow truck or whatever.
                This understanding has expanded to all sorts of different situations in life and I can say it’s
                one of the main lessons that touring has given me.
            </p>

            <p class="interview_question">
                In recent years you have spent most of your time on doing custom paint jobs and tattooing – things that
                are also creative. Is the harnessing of creativity in those actions comparable to music creation, or are
                they entirely different fields that stimulate you in entirely different ways?
            </p>
            <p class="interview_answer">
                I actually stopped tattooing this June after doing it for over 20 years. Custom paint stuff has
                mainly occupied my time in recent years and I’m also working on a custom car magazine and
                taking first steps in engraving and sculpture.
                I think I get a similar kick out of all of those creative activities and just the journey is
                different.
            </p>

            <p class="interview_question">
                Are there any musical odysseys left that you would like to undertake? Are there any experimental
                frontiers that you would like to conquer?
            </p>
            <p class="interview_answer">
                Oh yeah, definitely. Last year I released my first rap song (Morsakood - “Pan Tiit”), although I think
                it’s more of pop-electro kind of stuff with me rapping on it. It was a really good practice though,
                cause it
                was the first time ever I dared to “sing” with clean vocals, since I’ve only growled in the
                previous projects. Luckily for me it’s quite a naive piece and didn’t really demand too much
                of melodic efforts, so that’s why it probably sounds somewhat decent, haha.
                Then there’s some other stuff I’d like to do as well. Combining industrial, black metal, rap
                and drone is nothing new, but I have some ideas about it and I hope I can do it somewhat
                differently.
                I’ve also dwelled into some electronic hardcore and trance stuff, so I have some ideas of
                making this kind of stuff too, but adding a righteous amount of poisonous angle.
                Some darker kind of country stuff? Yes. Learn to sing with a clean voice? Yes (or maybe just
                learn how to fake it). We’ll see.
            </p>

            <p class="interview_question">
                15 years ago, in an interview given to the publication Eesti Ekspress, Taavet Jansen – a choreographer
                and interdisciplinary artist with whom you worked with on a theatre play – described Plastic Whore’s
                music as both enthralling and terrifying. Do you intend to terrify with your performance at Body Machine
                Body as well?
            </p>
            <p class="interview_answer">
                Haha, that’s not my goal really, but truth be told, I did perform half-naked, wearing some
                plastic costumes quite a few times too many at Plastic Whore shows – if I did that today, then
                that would possibly scare people off indeed.
            </p>

            <p class="interview_question">
                Will Body Machine Body be a one time resurrection of Plastic Whore, or do you have any further plans
                with the project? Moreover, do you still have a passion for that type of music?
            </p>
            <p class="interview_answer">
                I’m not gonna limit myself in this and as I’m rehearsing the songs now anyway, then I could
                just as well play some more shows too. When I first started rehearsing for this show I didn’t
                really think too much ahead and was rather doubtful about some more shows. But as I’m
                digging deeper into it I’m already getting ideas for making new songs and building it all up.
                So, I don’t really know where it all might end up, I just go for the ride and let it happen.
            </p>
        </div>

        <a id="veliu-namai-interview"></a>
        <div class="news-row" style="padding: 20px 0">
            <img class="news-photo" src="../assets/news/veliu_namai_interview.jpg"
                 @click="displayVeliuNamaiInterview = !displayVeliuNamaiInterview">
            <div class="news-row_column">
                <p class="news-header">Before the big event on October 19, Body Machine Body team is proud to indulge
                    you into the world
                    of one of our guests – Vėlių Namai from Lithuania, who mix together techno-inspired ambient and
                    neofolk.
                    Julius Mitė, the brain, brawn and spirit behind the project, kindly agreed to shed some light on
                    Vėlių Namai for those not yet acquainted with it.</p>
                <p class="news-header read-more" @click="displayVeliuNamaiInterview = !displayVeliuNamaiInterview">―
                    READ THE INTERVIEW WITH
                    V<span class="special-character">Ė</span>LI<span class="special-character">Ų</span> NAMAI BY MAGNUS
                    ALTKÜLA</p>
            </div>
        </div>
        <div v-show="displayVeliuNamaiInterview" class="interview">
            <p class="interview_question">
                Your last album Kúrir is about Baltic vikings known as The Curonians. What inspired you to create an
                album on such a topic? Why does their story intrigue you and why do you want to share it?
            </p>
            <p class="interview_answer">
                Before I started playing this style of music I used to mostly play folk-inspired ambient music. When
                playing live, the shows were very atmospheric and gloomy. Almost no one would dance, or dance in a very
                “ambient” way. I started to miss seeing people dance and have fun. I didn’t want to feel as if they are
                at a funeral. At the same time, I was occasionally listening to Wardruna and other similar bands and
                thought to myself, “maybe I should try something like this.” I thought that it would be a little bit
                disingenuous of me to do Viking music if I am not of Scandinavian descent… and then I discovered that
                Curonians are mentioned in different sagas… in which they are beating Vikings. That gave me an
                opportunity to try and do this type of music in a Baltic and my own way!
            </p>

            <p class="interview_question">
                Some neo-pagan acts like Wardruna and Heilung have gained a wide following in recent years. How do you
                as a fellow neo-pagan artist view those groups and their success? Do you find their success to be a
                positive/inspiring phenomenon or do you feel some other way about it?
            </p>
            <p class="interview_answer">
                Both Wardruna and Heilung have inspired me a lot. Wardruna has mostly inspired me with its music, I
                really think that it is a great band. On the other hand, Heilung has an amazing visual performance. I am
                in a sense trying to do something like them, but unique (Bowed Turkish baglama, inclusion of techno
                music, focus on the Baltic mythology and history, weird Julius vibe).
                P.s. I do kind of feel that Dead Can Dance has done it all already 30 years ago… What a band!
            </p>

            <p class="interview_question">
                It says in your bio that Vėlių Namai arose „from the longing felt for Lithuania and the distinctive
                Baltic worldview.“ Could you elaborate a bit on this distinct Baltic worldview and what it encompasses?
            </p>
            <p class="interview_answer">
                Difficult question, which begs for a very long answer. However, for me, in simple terms, it means being
                close to nature, respecting it, seeing the beauty in it… and let’s not forget about the world beyond! I
                believe that the thoughts about death in Baltic paganism are quite reassuring and beautiful, as weird as
                that sounds.
            </p>

            <p class="interview_question">
                During recent times, have you noticed people in general becoming more interested in the ways and stories
                of the past in Lithuania, or are you going against the grain with your interests?
            </p>
            <p class="interview_answer">
                I believe that there is a lot of interest in Lithuania. A lot of things that are taken for granted here
                can be seen as very weird abroad. That is, I can do the whole “Baltic spirit” performance and
                Lithuanians will be like “ok, cool” while let’s say in Holland or Italy I come across as very strange
                and confusing. Globally, I see the wave of “Cool Viking stuff” like the “Viking” series and the music
                associated with it slowly disappearing. Sadly, “Baltic Vikings” are not yet cool for an average Viking
                series fan, but maybe that’s good!
            </p>

            <p class="interview_question">
                How do you view the Baltics today? Has their evolution in the last 25 years been satisfactory to you and
                if you could change some things in Lithuania, what would they be? Also, how do you compare Lithuania to
                other Baltic countries?
            </p>
            <p class="interview_answer">
                I believe incredible effort and progress has been made. We went from almost nothing into successful,
                modern and democratic states. In 25 years! That’s amazing! However, Lithuania for example suffers
                heavily from inequality (1/3 of the country’s citizens are on the poverty line) … that must change.
                Also, recently, a lot of strange and plainly wrong policies have been implemented.
                I believe we could learn a bit from Estonia and Latvia in this regard, i.e. live and let live. But
                enough about politics.
            </p>

            <p class="interview_question">
                Do you still feel a bit of the ancient magic in different places around Lithuania, or in some facets of
                everyday life perhaps?
            </p>
            <p class="interview_answer">
                Completely! There are so many amazing places in Lithuania where you can still see ancient burial
                grounds, sacrificial stones, sacred trees etc. Even while I am writing this now, from Vilnius, the
                closest historical sacrificial stone is a mere 20 min walk away…

                Similarly, the Lithuanian language has kept a lot of ancient meanings and a hidden pagan worldview in
                it. One can simply look at the word “World” - “Pasaulis”, which literally translates as “the place under
                the sun”.
            </p>

            <p class="interview_question">
                Is Lithuania a good place to create music in and why or why not?
            </p>
            <p class="interview_answer">
                I believe it is a great place for creating music. The nature is good for it and at the same time it is
                much easier to grow with music in Lithuania. It would take me 6 months to find a good gig in Holland,
                while in Lithuania I could probably find one in a week or so. Also, Vilnius is crazy about music! There
                is so much cool stuff going on all the time! I love it.
            </p>

            <p class="interview_question">
                Music is, of course, a very personal and subjective experience to everyone, but is there also a goal for
                you with your own creation? Are there specific feelings or thoughts that you would like to evoke in
                listeners?
            </p>
            <p class="interview_answer">
                In regards to my goals, I would like to express myself in a sincere way while at the same time I would
                like the listeners to be entertained. In a perfect world, a listener that comes to my show would say
                that time has stopped for a second and that they have travelled somewhere, experienced something other
                than what they are used to.
            </p>

            <p class="interview_question">
                After releasing the video for your latest single „Aftensinn“, you have said that you would like to focus
                more on individual singles and videos above albums for some time. From where did this change in
                direction arose?
            </p>
            <p class="interview_answer">
                This came from the fact that I have rediscovered my other passion: filmmaking. I enjoyed filming
                “Aftensinn” a lot and that’s why my next big release will be a new song with a music video. It is close
                to being done and will be as professional as I can make it. It will also be quite bizarre.
            </p>

            <p class="interview_question">
                What would the perfect gig for you (as a performer) be like?
            </p>
            <p class="interview_answer">
                First of all, a perfect gig for me requires that all the technical details of my performance are
                executed. But most important would be that the listener would leave with an impression.
            </p>

            <p class="interview_question">
                Do you have any expectations before the Body Machine Body festival and your trip to Tallinn? Anything
                that you would like to experience while here?
            </p>
            <p class="interview_answer">
                First of all, the line-up is great! I can’t wait to see all the great performances! At the same time, I
                am of course really looking forward to playing in Tallinn and sharing my music. I will make sure to
                create a great, dark atmosphere and a 1042-styled party! Please feel welcome to find me after the show
                for a chat or a drink!
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'News',
        data() {
            return {
                displayVeliuNamaiInterview: false,
                displayPlasticWhoreInterview: false,
                displayBestialMouthsInterview: false,
                displayKirurgInterview: false
            }
        },
        created() {
            if (window.location.hash === '#veliu-namai-interview') {
                setTimeout(() => this.displayVeliuNamaiInterview = true, 1000)
            } else if (window.location.hash === '#plastic-whore-interview') {
                setTimeout(() => this.displayPlasticWhoreInterview = true, 1000)
            } else if (window.location.hash === '#bestial-mouths-interview') {
                setTimeout(() => this.displayBestialMouthsInterview = true, 1000)
            } else if (window.location.hash === '#kirurg-interview') {
                setTimeout(() => this.displayKirurgInterview = true, 1000)
            }
        }
    }
</script>

<style scoped>
    .news-row {
        background-color: #cdcdcd;
        display: flex;
        align-items: center;
        align-content: center;
        color: #cdcdcd;
        justify-content: center;
    }

    .news-row_column {
        width: 60%;
    }

    .news-header {
        margin-left: 40px;
        color: #232323;
        font-size: 21px;
        font-family: 'Tw Cen MT', 'Champagne-Limousines-Thick', 'Apple Gothic', 'URW Gothic L', 'Avant Garde', 'Futura';
        text-align: left;
    }

    .read-more {
        cursor: pointer;
        color: #4f4f4f;
        font-size: 22px;
        margin-top: 40px;
        font-family: 'Tw Cen MT', 'Champagne-Limousines-Thick', 'Apple Gothic', 'URW Gothic L', 'Avant Garde', 'Futura';
    }

    .read-more:hover {
        color: #7a7a7a;
    }

    .news-photo {
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
        width: 15%;
    }

    .news-photo:hover {
        cursor: pointer;
        -webkit-filter: grayscale(70%);
        filter: grayscale(70%);
    }

    .interview {
        color: #232323;
        text-align: left;
        width: 80%;
        margin: 0 auto;
        padding: 40px 0 80px;
        font-family: 'Tw Cen MT';
    }

    .interview_question {
        font-size: 21px;
        font-weight: bolder;
    }

    .interview_answer {
        margin-bottom: 20px;
        font-size: 21px;
    }

    .interview_answer:last-child {
        margin-bottom: 0;
    }

    .special-character {
        font-size: 20px;
    }

    @media (max-width: 425px) {
        .news-header {
            margin: 20px auto;
            text-align: center;
            font-size: 20px;
        }

        .news-row {
            display: table;
        }

        .news-row_column {
            margin: 0 auto;
            width: 90%;
        }

        .news-photo {
            width: 60%;
        }
    }
</style>